"use client";

/**
 * FooterContact.tsx
 *
 * Right-most column of the footer.
 * Shows address, phone, and email information.
 */

import React from "react";

interface FooterContactProps {
  title: string;
  address: string;
  phone: string;
  email: string;
}

const FooterContact = ({
  title,
  address,
  phone,
  email,
}: FooterContactProps) => {
  return (
    <div className="flex flex-col space-y-10">
      <h4 className="font-cormorant text-2xl font-bold uppercase tracking-widest text-white after:content-[''] after:block after:w-10 after:h-0.5 after:bg-[#c59d5f] after:mt-4">
        {title}
      </h4>
      <div className="flex flex-col space-y-4 text-sm font-light text-gray-400 group">
        <p className="group-hover:text-white transition-colors leading-relaxed">
          {address}
        </p>
        <p className="text-white font-bold group-hover:text-[#c59d5f] transition-colors">
          {phone}
        </p>
        <p className="group-hover:text-white transition-colors">{email}</p>
      </div>
    </div>
  );
};

export default FooterContact;
